import { createContext, useContext, useState, useEffect } from "react";
import en from "./content-en";
import ta from "./content-ta";

export const CONTENT = { en, ta };

const LangContext = createContext({ lang: "en", setLang: () => {}, t: en });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("dd-lang") || "en");
  useEffect(() => {
    localStorage.setItem("dd-lang", lang);
    document.documentElement.lang = lang === "ta" ? "ta" : "en";
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t: CONTENT[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
export const useContent = () => useContext(LangContext).t;
